/**
 * @generated SignedSource<<49f550ac29ce831b3c6982eabd38402b>>
 * @relayHash 8d31e888b41539c3272c18bfcbd98069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 56df07595a50e73beb875ed0e20d23725c8954e9834f6a1305370304adff931e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiJiraSoftwareEditSprintModalQuery } from './uiJiraSoftwareEditSprintModalQuery.graphql';

const node: PreloadableConcreteRequest<uiJiraSoftwareEditSprintModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "56df07595a50e73beb875ed0e20d23725c8954e9834f6a1305370304adff931e",
    "metadata": {},
    "name": "uiJiraSoftwareEditSprintModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
